import { FormField } from 'ui/formField';
import { InputField } from 'lib/iterable-hook-form';
import { useFormContext, useFormState } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getValidSendDomains } from '../selectors';
import type { AuthedEmailCreateFormProps } from '../types';
import type { SenderCreateFormContextType } from '../contexts/SenderCreateFormProvider';

export const AuthedEmailCreateForm = ({ formId, onSubmit }: AuthedEmailCreateFormProps) => {
  const { handleSubmit } = useFormContext<SenderCreateFormContextType>();
  const { errors } = useFormState<SenderCreateFormContextType>();
  const validSendDomains = useSelector(getValidSendDomains);

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <FormField
        errorText={errors.email?.message}
        hasError={!!errors.email?.message}
        inputId="emailFormFieldId"
        labelText="From email"
        helpText={
          validSendDomains.length > 0 &&
          `Must end in one of the following domains: ${validSendDomains.join(', ')}`
        }
      >
        <InputField
          id="emailFormFieldId"
          name="email"
          data-test="create-sender-email-field"
          autoFocus
        />
      </FormField>
      <FormField
        errorText={errors.senderName?.message}
        hasError={!!errors.senderName?.message}
        inputId="senderNameFormFieldId"
        labelText="From name"
      >
        <InputField
          id="senderNameFormFieldId"
          name="senderName"
          data-test="create-sender-senderName-field"
        />
      </FormField>
      <FormField
        errorText={errors.defaultReplyTo?.message}
        hasError={!!errors.defaultReplyTo?.message}
        inputId="defaultReplyToFormFieldId"
        labelText="From Default reply-to"
      >
        <InputField
          id="defaultReplyToFormFieldId"
          name="defaultReplyTo"
          data-test="create-sender-defaultReplyTo-field"
        />
      </FormField>
    </form>
  );
};
